// src/index.js

import React from "react"
import ReactDOM from "react-dom"
import Firebase, { FirebaseContext } from "./firebase"
import ErrorBoundary from "./utils/ErrorBoundary"

import { reportClientError } from "./utils/clientErrorReporter"

import "./styles/global.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import "./styles/rewrites.css"
import "primereact/resources/themes/bootstrap4-light-purple/theme.css"
import "primereact/resources/primereact.css"

// IMPORTANT: The "App" component must be imported after all global style imports.
// This order is critical to ensure correct style cascading and prevent unintended side effects.
import App from "./App"

// Install only once.
if (typeof window !== "undefined" && !window.__clientErrorTrackingInstalled) {
  window.__clientErrorTrackingInstalled = true

  // Rate-limit para evitar tormenta de errores
  window.__lastErrorSent = 0
  const safeReport = (data) => {
    const now = Date.now()
    if (now - window.__lastErrorSent < 2000) return
    window.__lastErrorSent = now
    reportClientError(data)
  }

  // --- Global JS Error ---
  window.onerror = function (message, source, lineno, colno, error) {
    safeReport({
      type: "js_error",
      message: String(message),
      filename: String(source),
      lineno,
      colno,
      stack: error?.stack || null,
      url: window.location.href,
      user_agent: navigator.userAgent,
      user: window.appUser?.id || "anonymous",
      organization_id: window.appUser?.organization_id || "",
      enterprise_id: window.appUser?.enterprise_id || "",
      participant_id: window.appUser?.participant_id || "",
      release: process.env.REACT_APP_BUILD_ID || "unknown",
      environment: process.env.NODE_ENV,
      timestamp: Date.now(),
    })
  }

  // --- Unhandled Promise Error ---
  window.addEventListener("unhandledrejection", (event) => {
    safeReport({
      type: "promise_error",
      message:
        event.reason?.message ||
        (typeof event.reason === "string"
          ? event.reason
          : "Unhandled Rejection"),
      stack: event.reason?.stack || null,
      url: window.location.href,
      user_agent: navigator.userAgent,
      user: window.appUser?.id || "anonymous",
      organization_id: window.appUser?.organization_id || "",
      enterprise_id: window.appUser?.enterprise_id || "",
      participant_id: window.appUser?.participant_id || "",
      release: process.env.REACT_APP_BUILD_ID || "unknown",
      environment: process.env.NODE_ENV,
      timestamp: Date.now(),
    })
  })
}

ReactDOM.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </FirebaseContext.Provider>,
  document.getElementById("root")
)
